import React from "react";
import { FormControl, FormGroup, FormHelperText } from "@mui/material";
import { SwitchFieldLabel, StyledSwitch } from "../styled/StyledSwitch.styled";
import { Controller } from "react-hook-form";

export default function StyledTextField({
  label = "",
  helperText,
  controller,
  name,
  register,
  labelPlacement="start",
  ...props
}) {
  return (
    <div style={{ marginBottom: "0px" }}>
      <FormControl variant="standard" sx={{ width: "100%" }}>
        <FormGroup aria-label="position" row>
          <SwitchFieldLabel
            control={
              <Controller
                control={controller}
                name={name}
                inputRef={register()}
                render={({ field: { value, ...field } }) => (
                  <StyledSwitch {...field} checked={!!value} size="medium" />
                )}
                defaultValue={false}
              />
            }
            labelPlacement={labelPlacement}
            label={label}
          />
          <FormHelperText error>{helperText}</FormHelperText>
        </FormGroup>
      </FormControl>
    </div>
  );
}
